
export const STEPS_STATES = {
    ACTIVE: "active",
    DISABLED: "disabled",
    COMPLETED: "completed",
}